export const siteUrl = 'https://dbdesign.io';

export const metaByLang = {
    en: {
        title: 'DB Design | Design & Share Database Diagrams',
        description: 'DB Design is a fast, intuitive workspace to design and refine database diagrams. Collaborate in real time, organize with areas and notes, and export production-ready SQL—so your team ships better schemas faster.',
    },
    'pt-BR': {
        title: 'DB Design | Crie e compartilhe diagramas de banco de dados',
        description: 'DB Design é um espaço rápido e intuitivo para criar e aprimorar diagramas de banco de dados. Colabore em tempo real, organize com áreas e notas e exporte SQL pronto para produção.',
    },
    ja: {
        title: 'データベースダイアグラムの設計と共有',
        description: '高速で直感的なワークスペース。リアルタイムで共同編集し、エリアやノートで整理して、SQLを本番用にエクスポートできます。',
    },
    fr: {
        title: 'DB Design | Concevoir et partager des diagrammes de bases de données',
        description: 'DB Design est un espace rapide et intuitif pour créer et affiner des diagrammes de bases de données. Collaborez en temps réel, organisez avec des zones et des notes, et exportez du SQL prêt pour la production.',
    },
    de: {
        title: 'DB Design | Datenbankdiagramme entwerfen und teilen',
        description: 'DB Design ist ein schnelles, intuitives Workspace, um Datenbankdiagramme zu entwerfen und zu verfeinern. Arbeite in Echtzeit zusammen, organisiere mit Bereichen und Notizen und exportiere produktionsreifes SQL.',
    },
    hi: {
        title: 'DB Design | डेटाबेस डायग्राम डिज़ाइन और साझा करें',
        description: 'DB Design एक तेज़, सहज वर्कस्पेस है जहाँ आप डेटाबेस डायग्राम बना और सुधार सकते हैं। रीयल-टाइम सहयोग करें, क्षेत्रों और नोट्स से व्यवस्थित करें, और प्रोडक्शन-रेडी SQL एक्सपोर्ट करें।',
    },
    id: {
        title: 'Rancang dan bagikan diagram basis data',
        description: 'DB Design adalah ruang kerja cepat dan intuitif untuk membuat serta menyempurnakan diagram basis data. Kolaborasi real-time, atur dengan area dan catatan, lalu ekspor SQL siap pakai.',
    },
    it: {
        title: 'DB Design | Progetta e condividi diagrammi di database',
        description: 'DB Design è un workspace rapido e intuitivo per creare e perfezionare diagrammi di database. Collabora in tempo reale, organizza con aree e note ed esporta SQL pronto per la produzione.',
    },
    ko: {
        title: '데이터베이스 다이어그램 설계 및 공유',
        description: '데이터베이스 다이어그램을 빠르고 직관적으로 설계하고 개선할 수 있는 워크스페이스입니다. 실시간 협업, 영역과 노트로 정리하며 프로덕션용 SQL을 내보낼 수 있습니다.',
    },
    pl: {
        title: 'DB Design | Projektuj i udostępniaj diagramy baz danych',
        description: 'DB Design to szybkie, intuicyjne środowisko do tworzenia i ulepszania diagramów baz danych. Współpracuj w czasie rzeczywistym, porządkuj w obszarach i notatkach, eksportuj SQL gotowy na produkcję.',
    },
    'zh-CN': {
        title: 'DB Design | 设计并分享数据库图',
        description: 'DB Design 是一个快速、直观的工作区，用于创建和完善数据库图。实时协作，用区域和笔记组织，并导出可用于生产的 SQL。',
    },
    es: {
        title: 'DB Design | Diseña y comparte diagramas de bases de datos',
        description: 'DB Design es un espacio rápido e intuitivo para crear y perfeccionar diagramas de bases de datos. Colabora en tiempo real, organiza con áreas y notas y exporta SQL listo para producción.',
    },
    th: {
        title: 'DB Design | ออกแบบและแบ่งปันไดอะแกรมฐานข้อมูล',
        description: 'DB Design คือเวิร์กสเปซที่รวดเร็วและใช้งานง่ายสำหรับสร้างและปรับปรุงไดอะแกรมฐานข้อมูล ทำงานร่วมกันแบบเรียลไทม์ จัดระเบียบด้วยพื้นที่และโน้ต และส่งออก SQL พร้อมใช้งานจริง.',
    },
    'zh-TW': {
        title: 'DB Design | 設計與分享資料庫圖',
        description: 'DB Design 是一個快速直覺的工作區，用來建立並優化資料庫圖。即時協作、以區域與筆記整理，並匯出可用於正式環境的 SQL。',
    },
    tr: {
        title: 'DB Design | Veritabanı diyagramları tasarlayın ve paylaşın',
        description: 'DB Design, veritabanı diyagramlarını hızlı ve sezgisel şekilde tasarlayıp geliştirmek için bir çalışma alanı sunar. Gerçek zamanlı işbirliği yapın, alanlar ve notlarla düzenleyin, üretime hazır SQL’i dışa aktarın.',
    },
    vi: {
        title: 'DB Design | Thiết kế và chia sẻ sơ đồ cơ sở dữ liệu',
        description: 'DB Design là workspace nhanh, trực quan để tạo và hoàn thiện sơ đồ cơ sở dữ liệu. Cộng tác thời gian thực, sắp xếp bằng khu vực và ghi chú, xuất SQL sẵn sàng cho sản xuất.',
    },
};

export const languages = Object.keys(metaByLang);
export const fallbackLng = 'en';
